import { render, staticRenderFns } from "./ResellerAccount.vue?vue&type=template&id=06b3d320&"
import script from "./ResellerAccount.vue?vue&type=script&lang=js&"
export * from "./ResellerAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports